module.exports = __webpack_public_path__ + "static/media/BM_Parts.c1640d43.svg";